import {reactive} from "vue";
import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";

class LancamentoEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerLancamentoGravado = reactive({value: {lancamentoId: ''}})
    listenerLancamentoAlterado = reactive({value: {lancamentoId: ''}})
    listenerLancamentoCancelado = reactive({value: {lancamentoId: ''}})
    listenerLancamentoPago = reactive({value: {lancamentoId: ''}})

    emitLancamentoGravado(lancamentoId: string) {
        this.listenerLancamentoGravado.value = {lancamentoId: lancamentoId}
    }

    emitLancamentoAlterado(lancamentoId: string) {
        this.listenerLancamentoAlterado.value = {lancamentoId: lancamentoId}
    }

    emitLancamentoCancelado(lancamentoId: string) {
        this.listenerLancamentoCancelado.value = {lancamentoId: lancamentoId}
    }

    emitLancamentoPago(lancamentoId: string) {
        this.listenerLancamentoPago.value = {lancamentoId: lancamentoId}
    }


}

export default LancamentoEvents;